import { Box, createTheme, ThemeProvider } from '@mui/material';
import Typography from '@mui/material/Typography';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import 'moment/locale/pt-br';
import React, { useRef } from 'react';
import { useLocale } from 'react-admin';
import { PrintButton, ReportPrint, Wrapper } from '../index';
import Permission from '../Permission';

const theme = createTheme({
    typography: {
        fontSize: 12,
    },
});

const FilterRow = ({ children }) => {
    return (
        <Box sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
        }}>
            {React.Children.map(children, child => child &&
                <Box sx={{
                    margin: '0 25px 15px 0',
                }}>
                    {child}
                </Box>
            )}
        </Box>
    )
}

const ActionRow = ({ children, printButton }) => {
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '10px 0'
        }}>
            {React.Children.map(children, child =>
                <Box sx={{
                    margin: '0 25px 0 0',
                    marginRight: 'auto',
                }}>
                    {child}
                </Box>
            )}
            {printButton}
        </Box>
    )
}

export default function ReportLayout({ filters, permission, title, filterTablePrint, content, landscape, actions }) {
    const reportRef = useRef();
    const locale = useLocale();
    return (
        <Permission permission={permission}>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
                <Wrapper>
                    <FilterRow>
                        {filters}
                    </FilterRow>
                    <ActionRow printButton={<PrintButton printRef={reportRef} />}>
                        {actions}
                    </ActionRow>
                    <ReportPrint ref={reportRef} title={title} landscape={landscape ? true : false}>
                        <Box sx={{
                            display: 'none',
                            '@media print': {
                                display: 'block'
                            }
                        }}>
                            {filterTablePrint}
                        </Box>
                        {content}
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                        }}>
                            <ThemeProvider theme={theme}>
                                <Typography variant="subtitle1">Relatório gerado em: {moment().format('DD/MM/YYYY HH:mm:ss')}</Typography>
                            </ThemeProvider>
                        </Box>
                    </ReportPrint>
                </Wrapper>
            </LocalizationProvider>
        </Permission>
    )
}
